(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools",
                {
                    url: "/Tools",
                    component: "tools",
                    PageTitle: "Tools",
                    resolve: {
                        //masterAdvisorAgreementSignatureRequiredModel: ["agreementsApi", function (agreementsApi) {
                        //    return agreementsApi.getMasterAdvisorAgreementRequiredModel().then(function (model) {
                        //        return model;
                        //    });
                        //}],
                        //masterAdvisorAgreements: ["agreementsApi", function (agreementsApi) {
                        //    return agreementsApi.getLoggedInUserMasterAdvisorAgreements().then(function (agreements) {
                        //        return agreements;
                        //    });
                        //}]
                    }
                });
        }
    ]);

    app.component("tools",
        {
            templateUrl: "App/Tools/tools-template.html",
            controller: toolsController,
            bindings: {
                masterAdvisorAgreementSignatureRequiredModel: "<",
                masterAdvisorAgreements: "<"
            }
        });


    toolsController.$inject = ["$mdDialog", "$state", "$timeout", "permissionService"];


    function toolsController($mdDialog, $state, $timeout, permissionService) {
        var $ctrl = this;

    }

    app.config(["$urlRouterProvider", function ($urlRouterProvider) {
        $urlRouterProvider.when("/Tools", "/Home");
    }]);

})(window.app); // jshint ignore:line